<div>
  {{value}}
</div>
